import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
import noop from 'lodash/noop';
import { useTranslation } from 'react-i18next';
import ChatInput from '../chat-input';
import { composerActions } from '../composer-actions';
import ComposerDisclaimer from '../composer-disclaimer';

// `readOnly` matches the transcript's layout (no composer, viewport-capped height) so the
// loading state doesn't jump to a different size once messages arrive.
const ChatMessagesSkeleton = t0 => {
  const $ = _c(13);
  const {
    readOnly: t1
  } = t0;
  const readOnly = t1 === undefined ? false : t1;
  const {
    t
  } = useTranslation("copilot");
  const t2 = `relative flex flex-col ${readOnly ? "min-h-[calc(100vh-100px)]" : "h-full"}`;
  const t3 = `max-w-[820px] w-full mx-auto pb-8 flex flex-col gap-3 ${readOnly ? "px-4 md:px-8 pt-8" : "px-4 pt-6 md:pt-20"}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-end"><Shimmer className="rounded-lg" height={40} width={220} /></div>;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-2 max-w-[80%]"><Shimmer className="rounded-md" height={16} width="92%" /><Shimmer className="rounded-md" height={16} width="78%" /><Shimmer className="rounded-md" height={16} width="64%" /></div>;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex justify-end"><Shimmer className="rounded-lg" height={32} width={160} /></div>;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col gap-2 max-w-[80%]"><Shimmer className="rounded-md" height={16} width="88%" /><Shimmer className="rounded-md" height={16} width="70%" /></div>;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t3) {
    t8 = <div className="flex-1 overflow-hidden"><div className={t3}>{t4}{t5}{t6}{t7}</div></div>;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== readOnly || $[7] !== t) {
    t9 = !readOnly && <div className="relative px-3 pb-[max(1rem,env(safe-area-inset-bottom))] group-data-[keyboard-open]/app:pb-3 flex flex-col items-center max-w-[820px] w-full mx-auto"><div className="absolute -top-6 left-0 right-0 h-6 bg-gradient-to-t from-primary to-transparent pointer-events-none" /><div className="flex flex-col w-full gap-2"><ChatInput {...composerActions({
          env: {}
        })} placeholder={t(_temp)} disabled={true} enableEntityMentions={false} onSendMessage={_temp2} rows={2} /></div><ComposerDisclaimer className="w-full" /></div>;
    $[6] = readOnly;
    $[7] = t;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t2 || $[10] !== t8 || $[11] !== t9) {
    t10 = <div className={t2}>{t8}{t9}</div>;
    $[9] = t2;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
};
export default ChatMessagesSkeleton;
function _temp($) {
  return $.chat.replyPlaceholder;
}
async function _temp2() {
  return noop();
}